var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArtLeftImage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 120,
    viewBox: "0 0 161 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0242 13.1004L11.4941 18.0254L16.4191 26.5555L24.9492 21.6305L20.0242 13.1004Z",
    fill: "#FFA940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9477 81.2711L79.3574 79.4727L77.559 84.063L82.1493 85.8614L83.9477 81.2711Z",
    stroke: "#FFA940",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.2 12.6891L126.609 10.8906L124.811 15.4809L129.401 17.2794L131.2 12.6891Z",
    stroke: "#FFA940",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.87953 95.9199L0.769531 106.61L10.5795 102.22L1.87953 95.9199Z",
    fill: "#FFA940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.539 118.86C104.159 118.86 103.789 118.72 103.499 118.43C102.919 117.85 102.919 116.92 103.499 116.35L106.199 113.65C106.779 113.07 107.709 113.07 108.279 113.65C108.859 114.23 108.859 115.16 108.279 115.73L105.579 118.43C105.289 118.72 104.909 118.86 104.539 118.86Z",
    stroke: "#FFA940",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.5396 7.71984C71.5775 7.71984 73.2296 6.06777 73.2296 4.02984C73.2296 1.99191 71.5775 0.339844 69.5396 0.339844C67.5017 0.339844 65.8496 1.99191 65.8496 4.02984C65.8496 6.06777 67.5017 7.71984 69.5396 7.71984Z",
    fill: "#FFA940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2396 103.219C73.1454 103.219 73.8796 102.485 73.8796 101.579C73.8796 100.674 73.1454 99.9395 72.2396 99.9395C71.3339 99.9395 70.5996 100.674 70.5996 101.579C70.5996 102.485 71.3339 103.219 72.2396 103.219Z",
    stroke: "#FFA940",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5703 15.2598L66.1803 28.3998",
    stroke: "#FFA940",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8906 116.909L107.541 102.539",
    stroke: "#FFA940",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5898 90.0291L110.71 89.8691",
    stroke: "#FFA940",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.58008 70.1307C5.11008 71.2507 6.90008 71.9407 8.72008 72.4607C12.9101 73.6407 17.4701 73.8807 21.5701 72.4107C25.6701 70.9407 29.2101 67.5907 30.2301 63.3607C31.2501 59.1307 29.3301 54.1807 25.4101 52.3007C23.1301 51.2007 20.4401 51.1907 17.9901 51.8207C16.7801 52.1307 15.5801 52.6007 14.6401 53.4307C11.7001 56.0307 12.6701 61.2707 15.7501 63.7207C18.8301 66.1707 23.1201 66.4007 27.0101 65.8307C30.5301 65.3207 34.1601 64.1007 36.4101 61.3607C37.5701 59.9407 38.2901 58.2107 38.7901 56.4507C39.9101 52.5607 40.0701 48.3007 38.5701 44.5407C37.2201 41.1407 34.3701 38.2407 30.8801 37.2207",
    stroke: "#FFA940",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2293 36.0707L31.1793 37.3007L32.4093 39.3607L31.0093 39.0107L29.7793 36.9507L31.8393 35.7207L33.2293 36.0707Z",
    fill: "#FFA940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3701 102.209V86.9395H26.4101V102.209L22.0801 110.329L33.8301 102.609H48.0801",
    stroke: "#FFA940",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.23 103.06C152.928 103.06 160.79 95.1983 160.79 85.5002C160.79 75.8021 152.928 67.9402 143.23 67.9402C133.532 67.9402 125.67 75.8021 125.67 85.5002C125.67 95.1983 133.532 103.06 143.23 103.06Z",
    fill: "#F76707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.33 102.61C150.028 102.61 157.89 94.7484 157.89 85.0502C157.89 75.3521 150.028 67.4902 140.33 67.4902C130.631 67.4902 122.77 75.3521 122.77 85.0502C122.77 94.7484 130.631 102.61 140.33 102.61Z",
    fill: "#FFC078"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.14 77.1903C151.79 80.4603 145.04 92.4203 145.04 92.4203C145.04 92.4203 131.91 89.8903 132.09 84.1403C132.31 77.1903 139.61 80.6703 139.61 80.6703C139.61 80.6703 141.75 73.4003 147.14 77.1903Z",
    fill: "#FD7E14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.52 89.8202C128.98 96.6502 136.5 100.18 143.33 97.7202",
    stroke: "white",
    strokeWidth: 0.855,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.25 48.8203C62.25 48.8203 83.7 79.8403 123.52 59.4203",
    stroke: "#FFA940",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.49 61.8004L123.25 59.5304L120.98 58.7704L122.27 58.1304L124.54 58.8904L123.78 61.1604L122.49 61.8004Z",
    fill: "#FFA940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3995 52.7598C107.18 52.7598 115.109 44.8308 115.109 35.0498C115.109 25.2689 107.18 17.3398 97.3995 17.3398C87.6185 17.3398 79.6895 25.2689 79.6895 35.0498C79.6895 44.8308 87.6185 52.7598 97.3995 52.7598Z",
    fill: "#F76707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.3096 50.4598C108.091 50.4598 116.02 42.5308 116.02 32.7498C116.02 22.9688 108.091 15.0398 98.3096 15.0398C88.5286 15.0398 80.5996 22.9688 80.5996 32.7498C80.5996 42.5308 88.5286 50.4598 98.3096 50.4598Z",
    fill: "#FFE8CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.0898 36.9698C97.2598 40.5698 104.35 39.3098 107.95 34.1398",
    stroke: "#FFA940",
    strokeWidth: 1.0949,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5595 21.5398L90.3095 24.4998L94.8795 23.0898L93.2195 27.5698L95.9795 31.4798L91.1995 31.2898L88.3395 35.1198L87.0395 30.5198L82.5195 28.9798L86.4895 26.3198L86.5595 21.5398Z",
    fill: "#FFA940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.5293 20.1198L103.229 19.2198L105.139 14.8398L107.449 19.0298L112.209 19.4998L108.939 22.9898L109.959 27.6598L105.639 25.6298L101.509 28.0398L102.099 23.2998L98.5293 20.1198Z",
    fill: "#FFA940"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtLeftImage);
export default __webpack_public_path__ + "static/media/artLeftImage.a03fbc22663967533dd0ccc4e5549240.svg";
export { ForwardRef as ReactComponent };